/**
 * Angular 2 decorators and services
 */
import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

import { E2E_ATTRIBUTES } from '@app/shared/types/enums/e2e-attributes.enum';

@Component({
  selector: 'modal-content',
  templateUrl: './modal-content.component.html',
  styleUrls: ['modal-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})

/**
 *
 * Modal Content component.
 * @class ModalContentComponent
 *
 */
export class ModalContentComponent {
  @HostBinding('attr.e2e-attr')
  public e2eAttr: string = E2E_ATTRIBUTES.MODAL_CONTENT;
}
